import AbstractTrack from 'common/services/doxy-analytics/abstract.track';
import { RootScopeEvents } from 'common/services/root-scope-types';
export default class CreateSharedRoomTrack extends AbstractTrack {
    constructor() {
        super(...arguments);
        this.eventNameSegment = 'create shared room';
    }
    start() {
        this.$rootScope.$on(RootScopeEvents.CLINIC_SETTINGS.CREATE_SHARED_ROOM_MODAL_CLICKED, ($e, data) => {
            this.trackButtonEventSegment(data);
        });
    }
}
